import { createAsyncThunk } from "@reduxjs/toolkit";
import { getOffers, getReferral } from "../../../../utils/services/offers/offerService";

export const fetchOffers = createAsyncThunk(
  "offers/fetch",
  async (_, thunkAPI) => {
    console.log("thunkApii", thunkAPI);

    const { page, limit } = thunkAPI.getState().offers;

    const payload = {
      page: page + 1,
      limit: limit,
    };
    console.log("dddddfirst", payload);

    try {
      const response = await getOffers(payload);
      return response;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }
);

export const fetchReferral = createAsyncThunk(
  "referral/fetch",
  async (month, thunkAPI) => {
console.log(month,'apihit');
    const { referralPage, referralLimit } = thunkAPI.getState().offers;

    const payload = {
      page: referralPage + 1,
      limit:referralLimit,
      month:month?.$d 
    };

    console.log("apihit");

    try {
      const response = await getReferral(payload);
      return response;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }
);
